import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { uniqueKey } from '../../../../global/common/keys'
import MatchTracker from './MatchTracker'
import MatchScores from './MatchScores'

const MatchResultsRt = (props) => {

  const { match, match_realTime } = props
  const { _results, _results_realtime, _scorer, home, away } = match
  const { scoreDisplays: scoreDisplays_m } = _results ?? {}
  const { score: score_rt, scores: scores_rt, setNumber, complete: complete_rt, scoreDisplays: scoreDisplays_rt } = _results_realtime ?? {}
  const { scores: scores_display_m } = scoreDisplays_m ?? {}
  const { scores: scores_display_rt } = scoreDisplays_rt ?? {}

  const lastStat = useMemo(() => {
    const mrt = match_realTime ? _.head(_.values(match_realTime)) : {}
    const { tracker } = mrt ?? {}
    const { pointHistory } = tracker ?? {}
    const lastPoint = pointHistory ? _.last(pointHistory) : null
    const { winner, selectedStat } = lastPoint ?? {}
    const lastTeamWinner = winner === 'away' ? away?.name : home?.name
    if (lastTeamWinner && selectedStat) {
      const { stat, selectedPlayer } = selectedStat
      switch (stat) {
        case 'OTE':
          return stat
        default:
          const { uniformNumber, firstName, lastName } = selectedPlayer ?? {}
          return lastTeamWinner + ' - ' + stat + ' - ' + uniformNumber + ' - ' + firstName + ' ' + lastName
      }

    } else {
      return ''
    }
  }, [match_realTime])

  let scoreDisplay;

  if (scores_display_m) {
    scoreDisplay = scores_display_m
  } else if (complete_rt) {
    scoreDisplay = scores_display_rt
  }

  switch (match._itemKey) {
    case 'E3su3OgDJrcrkAZRprJW':
      console.log('match >>> ', match)
  }

  const [awayScore, setAwayScore] = useState(0)
  const [homeScore, setHomeScore] = useState(0)
  const [hasMounted, setHasMounted] = useState(false)
  const [flashAway, setFlashAway] = useState(false);
  const [flashHome, setFlashHome] = useState(false);

  useEffect(() => {
    if (scores_rt) {
      const _away = scores_rt && scores_rt[setNumber] && scores_rt[setNumber].away ? scores_rt[setNumber].away : 0
      const _home = scores_rt && scores_rt[setNumber] && scores_rt[setNumber].home ? scores_rt[setNumber].home : 0

      setAwayScore(_away)
      setHomeScore(_home)

      if (hasMounted) {
        if (_away !== awayScore) { setFlashAway(true); }
        if (_home !== homeScore) { setFlashHome(true); }
        const timeout = setTimeout(() => {
          setFlashAway(false);
          setFlashHome();
        }, 1000);

        return () => clearTimeout(timeout);
      } else {
        setHasMounted(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scores_rt]);

  const scoreElements = () => <MatchScores results={_results} />

  const match_scores = () => {

    const spans = []
    const divs = []

    _.forEach(scores_rt, (score, _setNumber) => {
      const { away, home } = score
      let cns_a = ''
      let cns_h = ''
      const ah = away + '-' + home
      spans.push(<span>{ah}</span>)
      if (parseInt(_setNumber) < parseInt(setNumber)) {
        if (away > home) {
          cns_a = 'tw'
        } else if (away < home) {
          cns_h = 'tw'
        }
      } else {
        if (away > home) {
          cns_a = 'tu'
          cns_h = 'td'
        } else if (away < home) {
          cns_h = 'tu'
          cns_a = 'td'
        } else {
          cns_a = 'tt'
          cns_h = 'tt'
        }
      }
      if (parseInt(_setNumber) === parseInt(setNumber)) {
        if (flashAway) { cns_a += ' flash-away' }
        if (flashHome) { cns_h += ' flash-home' }
      }
      const _div = []
      _div.push(<div className={cns_a}>{away}</div>)
      _div.push(<div className={cns_h}>{home}</div>)
      divs.push(<div>{_div}</div>)
    })

    const _divs = []
    _divs.push(<div>{score_rt?.away}</div>)
    _divs.push(<div>{score_rt?.home}</div>)
    divs.unshift(<div>{_divs}</div>)

    const _divt = []
    _divt.push(<div>{match?.away?.name}</div>)
    _divt.push(<div>{match?.home?.name}</div>)
    divs.unshift(<div>{_divt}</div>)

    return <div className='match-rtr-full'>
      {divs}
    </div>
  }

  const match_results_rt = () => {
    let cn = 'match-rtar rt'
    return <div className={cn}>
      <div className={'mrl'}>
        {match_scores()}
      </div>
      <div key={uniqueKey('mrrt', 4)} className={'mrt-sr'}>{_scorer}</div>
      {lastStat && <div key={uniqueKey('mrrt', 4)} className={'mrt-st'}>{lastStat}</div>}
      {/* <MatchTracker /> */}
    </div>
  }

  const match_results_scores = () => {
    let cn = 'match-rtar scr'
    return <div className={cn}>
      <div className={'mrl'}>
        {scoreElements()}
      </div>
    </div>
  }

  return scoreDisplay ? match_results_scores() : match_results_rt()
}

export default MatchResultsRt